module.exports = "/_next/static/images/ba01c62488a37527185a7d84d400ff25-four-cards-full.svg.webp";